module.exports = __webpack_public_path__ + "img/big.4c66ec97.jpg";